import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

import { DevicesStore, InstallationFeaturesStore } from '@store';
import {
  Feature,
  PvHeaterPowerConsumptionCurrentProperties,
} from '@vi-iot/client/apis/operational-data/operational-data.model';
import { FeatureNames, FeaturePropertyKey } from '@vi-iot/client/index';
import { NO_VALUE } from '@pipes';

import { filter, takeUntil } from 'rxjs/operators';

import { Observable, Subject } from 'rxjs';
import { SUFFIX } from 'src/app/shared/common/units';

@Component({
  selector: 'app-pv-heater',
  templateUrl: './pv-heater.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PvHeaterComponent implements OnInit, OnDestroy {
  readonly FeaturesDetailsOverlayTypeEnum = FeaturesDetailsOverlayTypeEnum;
  readonly featurePropertyKey = FeaturePropertyKey;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  PvHeaterPowerConsumptionCurrent$: Observable<
    Feature<PvHeaterPowerConsumptionCurrentProperties, never>
  >;
  selectedDeviceId: string;
  availableOverlays = FeaturesDetailsOverlayTypeEnum;
  NO_VALUE = NO_VALUE;
  SUFFIX = SUFFIX;

  constructor(
    private devicesStore: DevicesStore,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.devicesStore.selectedDevice$
      .pipe(
        filter((dev) => Boolean(dev)),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((device) => {
        this.selectedDeviceId = device.selectId;
        this.PvHeaterPowerConsumptionCurrent$ = this.installationFeaturesStore.selectInstallationDeviceFeature<
          PvHeaterPowerConsumptionCurrentProperties,
          never
        >(FeatureNames.pvHeaterPowerConsumptionCurrent, device.id);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
